export * from './visualizador.component';
